import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  AdjudicateBackgroundCheckRequest,
  BackgroundCheckResponse
} from '@umss/shared/data-access';

@Injectable({ providedIn: 'root' })
export class BackgroundCheckAdminService {
  private readonly http = inject(HttpClient);

  getLatest(contractorId: string): Observable<BackgroundCheckResponse> {
    return this.http.get<BackgroundCheckResponse>(
      `/api/contractors/${contractorId}/background-checks/latest`
    );
  }

  adjudicate(
    backgroundCheckId: string,
    request: AdjudicateBackgroundCheckRequest
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `/api/background-checks/${backgroundCheckId}/adjudicate`,
      request
    );
  }

  getReport(backgroundCheckId: string): Observable<Blob> {
    return this.http.get(`/api/background-checks/${backgroundCheckId}/report`, {
      responseType: 'blob'
    });
  }
}
